import { render, staticRenderFns } from "./veStuStipendShen.vue?vue&type=template&id=69c5290e&scoped=true"
import script from "./veStuStipendShen.vue?vue&type=script&lang=js"
export * from "./veStuStipendShen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c5290e",
  null
  
)

export default component.exports